<template>
  <div>
  <div class="row">
      <div class="col-md-12 card">
          <div class="card-header">
            <div class="row">
               <div class="col-md-6">
                  <h3 class="title">{{ $t('reports') }} <span style="color: #FDCB6A">|</span>{{ $t('soil_list') }}</h3>
               </div>
               <div class="col-md-3">
                 <fg-input>
                    <el-select size="large" @change="getFarmerData" class="select-primary" v-model="form.countryID" filterable clearable :placeholder="('select_country')">
                        <el-button @click.prevent="getSearchData('country')" style="width:100%; border:none">{{$t('all')}}</el-button>
                        <el-option
                          class="select-primary"
                          v-for="country in Countries"
                          :key="country.id"
                          :label="country.name"
                          :value="country.name"></el-option>
                    </el-select>
                 </fg-input>
               </div>
               <div class="col-md-3">
                  <fg-input>
                      <el-select size="large" @change="getFarmerData" class="select-primary" v-model="form.ngoID" value-key="0" filterable clearable :placeholder="$t('select_gno')">
                          <el-button @click.prevent="getSearchData('ngo')" style="width:100%; border:none">{{$t('all')}}</el-button>
                          <el-option
                            class="select-primary"
                            v-for="ngo in NGO"
                            :key="ngo.id"
                            :label="ngo.name"
                            :value="ngo.name"></el-option>
                      </el-select>
                  </fg-input>
               </div>
            </div>

          </div>
          <div class="card-body">
            <div class="row">
                  <div class="col-md-6">
                  <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                    <el-option
                      class="select-default"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                      </el-option>
                  </el-select>
                </div>
                <div class="col-sm-6">
                  <div class="pull-right">
                    <fg-input
                      class="input-sm"
                      placeholder="Search"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split"
                    ></fg-input>
                  </div>
                </div>
              </div>
             <div class="row">
                  <el-table v-loading="loading" :element-loading-text="$t('loading_data')+'...'" class="table-striped" :data="paginated" border style="width: 100%">
                    <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                      :prop="column.prop" :label="column.label" sortable="">
                    </el-table-column>
                    <el-table-column fixed="right" class-name="td-actions text-center" :label="$t('actions')">
                       <template slot-scope="props">
                            <p-button type="primary" title="View Field Scan" size="sm" icon @click="handleViewData(props.$index, props.row)">
                              <i class="fa fa-eye"></i>
                            </p-button>
                       </template>
                    </el-table-column>
                  </el-table>
             </div>
          </div>
          <div class="card-footer">
             <div class="row">
                <div class="col-sm-6 pagination-primary">
                  <p class="category">{{$t('showing')}} {{pagination.from}} {{$t('to')}} {{pagination.to}} {{$t('of')}} {{pagination.total}} {{$t('entries')}}</p>
                </div>
                <div class="col-sm-6">
                  <p-pagination
                    class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total"></p-pagination>
                </div>
             </div>
          </div>
      </div>
  </div>
  <div class="row mt-4">
      <div class="navBottom pull-right">
        <p-button class="btn btn-deepDark">
            <span>{{$t('export_to_xls')}}</span> <i class="fa fa-file-excel-o" style="padding-left:15px"></i>
        </p-button>
        <p-button class="btn btn-yellow" @click.prevent="goToShowSoilMap">
            <span>{{ $t('show_map') }}</span> <i class="fa fa-map-marker fa-lg" style="padding-left:15px"></i>
        </p-button>
      </div>
    </div>
  </div>
</template>
<script>
import Resource from "@/util/Api/resource.js";
import PPagination from "src/components/UIComponents/Pagination.vue";
//import { parse } from 'fullcalendar/src/datelib/parsing';
const NGOResources = new Resource("category/childrenGivenParent");
const farmerResource =  new Resource('soilcare');
export default {
  components: {
    PPagination,
  },
  data() {
    return {
      tableColumns: [
        {prop: "name", label: this.$t("name")},
        {prop: "measurements", label: this.$t("measurements")},
        {prop: "dateFirstScan", label: this.$t("date_for_first_scan")},
      ],
      NGO:[],
      Countries:[],
      tableData:[],
      farmers:[],
      searchQuery:'',
      form:{
        countryID:'',
        ngoID:''
      },
      loading:false,
      pagination:{
          perPage: 10,
          perPageOptions: [10, 20, 30, 60, 500, 1000],
          currentPage:1,
          nextPage:'',
          prevPage:'',
          total:'',
          from:'',
          to:'',
          page:'',
      },
    }
  },

  methods: {

    // Get all countries in a category
    async getCountry() {
      await NGOResources.get(2).then(response => {
        this.Countries = response.data;
      }).catch(error => {
         console.log('Failed getting all country data')
      });
    },

    // Get all NGOs in a categories
    async getNGOs() {
      await NGOResources.get(1).then(response => {
        this.NGO = response.data;
      }).catch(error => {
         console.log('Failed getting NGO data')
      });
    },

    // get farmer data
    async getFarmerData(){
        this.loading = true;
        this.farmers = [];
        this.tableData = [];

        if(this.form.countryID === ""){
          this.form.countryID = 0;
        }

        if(this.form.ngoID === "") {
          this.form.ngoID = 0;
        }

        await farmerResource.viewFarmer(this.form.countryID, this.form.ngoID)
        .then((response) => {

            let farmers = response.data.result;
            let obj = {};

            //console.log('data', farmers);
            farmers.forEach(element => {
                obj = {};
                obj = {
                  name: element.name,
                  measurements: element.measurements,
                  dateFirstScan: this.getNumberFromString(element.dateFirstScan),
                  link:element.link,
                }
                this.farmers.push(obj);
            });

            this.tableData = this.farmers;

        }).catch((error) => {
           console.log(`Failed search data ${error}`);
        }).finally(() => {
            this.loading = false;

            if(this.form.countryID === 0){
              this.form.countryID = "";
            }

            if(this.form.ngoID === 0) {
              this.form.ngoID = "";
            }
        });
    },

    // searching data
    async getSearchData(show){
        this.loading = true;
        this.farmers = [];
        this.tableData = [];

        if(show === "country"){

          this.form.countryID = 0;
          if(this.form.ngoID === "") {
            this.form.ngoID = 0;
          }

        } else if (show === "ngo") {

          this.form.ngoID = 0;
          if(this.form.countryID === ""){
            this.form.countryID = 0;
          }

        }

        await farmerResource.viewFarmer(this.form.countryID, this.form.ngoID)
        .then((response) => {

            let farmers = response.data.result;
            let obj = {};

            farmers.forEach(element => {
                obj = {};
                obj = {
                  name: element.name,
                  measurements: element.measurements,
                  dateFirstScan: this.getNumberFromString(element.dateFirstScan),
                  link:element.link,
                }
                this.farmers.push(obj);
            });

            this.tableData = this.farmers;

        }).catch((error) => {
           console.log(`Failed search data ${error}`);
        }).finally(() => {
            this.loading = false;

            if(this.form.countryID === 0){
              this.form.countryID = "";
            }

            if(this.form.ngoID === 0) {
              this.form.ngoID = "";
            }
        });
    },

    // function to extract number from string
    getNumberFromString(text){
      var date = "";
      if(text){
          var currentTime = new Date(text);
          var month = currentTime.getMonth() + 1;
          var day = currentTime.getDate();
          var year = currentTime.getFullYear();
          date = day + "/" + month + "/" + year;
      } else {
         date = "";
      }

      return date;
    },

    // editing function
    handleViewData(index, row){
       //console.log('row', row);
       localStorage.setItem("soilLink", row.link);
       this.$router.push({ name: "ViewSoilList"});
    },

    // showing soil list
    goToShowSoilMap(){
       this.$router.push({ name: "ShowMap" });
    },

    paginate(array, length, pageNumber){
        this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
        this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
        this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
        this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
        this.pagination.page = Math.ceil(array.length / length);
        this.pagination.total = array.length;
        return array.slice((pageNumber - 1) * length, pageNumber * length);
    },


  },

  mounted() {
    this.getNGOs();
    this.getCountry();
    this.getFarmerData();
  },

  computed: {

        queriedData() {
            let result = this.tableData;
            if (this.searchQuery) {
                result = result.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return (String(row[key]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1);
                    })
                })
            }
            return result;
        },

        paginated(){
            return this.paginate(this.queriedData, this.pagination.perPage, this.pagination.currentPage);
        },

     },

}
</script>
<style scoped>

  .btn-deepDark {
      background-color: #000000;
      color: white;
      margin-right: 10px;
  }

  .btn-yellow {
     background-color: #FEB936;
     color: #000000;
  }

  .navBottom {
      display: flex;
      position: absolute;
      right: 0;
      width: 330px;
      bottom: 70px;
  }

</style>
